module.exports = __webpack_public_path__ + "img/cart-empty.8b316431.png";